import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EmployeeDoc } from '../_models/employeeDoc';

@Injectable()
export class EmployeeDocService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getEmployeeDocs(): Observable<EmployeeDoc[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/employeeDocs')
      .pipe(map((response) => response));
  }

  getEmployeeDoc(id: number): Observable<EmployeeDoc> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/employeeDocs/' + id)
      .pipe(map((response) => response));
  }

  saveEmployeeDoc(employeeDocItem): Observable<EmployeeDoc> {
    const employeeDoc = { ...employeeDocItem };
    delete employeeDoc.lastUpdated;
    delete employeeDoc.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    employeeDoc.companyId = companySelected ? companySelected.id : null;

    if (employeeDoc.user != null && employeeDoc.user.id != null) {
      employeeDoc.user = { id: employeeDoc.user.id };
    }
    if (employeeDoc.id) {
      return this.http
        .put<EmployeeDoc>(
          this.apiBaseUrl + 'api/private/v1/employeeDocs/' + employeeDoc.id,
          employeeDoc
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<EmployeeDoc>(this.apiBaseUrl + 'api/private/v1/employeeDocs/', employeeDoc)
        .pipe(map((response) => response));
    }
  }

  deleteEmployeeDoc(id: number): Observable<EmployeeDoc> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/employeeDocs/' + id).pipe(
      map((response) => {
        return { id } as EmployeeDoc;
      })
    );
  }

  typeOfDoc(): Array<string> {
    return [
      'phytosanitary-licence',
      'work-permit',
      'medical-examination',
      'fire-prevention',
      'first-aid',
      'contract',
      'other',
    ];
  }
}
